import React from 'react';
import styled from 'styled-components';
import {
  DeliveryRateIcon,
  OpenRateIcon,
  ClickThroughRateIcon,
  BounceRateIcon,
  DropRateIcon,
  SpamReportIcon,
} from '../../../../Component/Analytics/Components/SVGs/Icons';
import { formatRate } from '../../utils/rates';
import { BLUE, GREY_TEXT, TILE_BACKGROUND } from '../../AnalyticsV2.styled';

export const TILE_ICONS = {
  delivery: DeliveryRateIcon,
  open: OpenRateIcon,
  clickThrough: ClickThroughRateIcon,
  bounce: BounceRateIcon,
  drop: DropRateIcon,
  spam: SpamReportIcon,
};

const Tile = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 94px;
  height: 52px;
  border: none;
  border-radius: 6px;
  background: ${TILE_BACKGROUND};
  font-size: 15px;
  font-weight: 600;
  color: ${({ disabled }) => (disabled ? GREY_TEXT : BLUE)};
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  svg,
  img {
    width: 18.5px;
    height: 18.5px;
    min-width: 18.5px;
    min-height: 18.5px;
    max-width: 18.5px;
    max-height: 18.5px;
    flex-basis: 18.5px;
  }
`;

// rate is a number, or null when the message has no data ("–").
// A "–" tile is not clickable.
const StatTile = ({ tileKey, rate, onClick }) => {
  const Icon = TILE_ICONS[tileKey];
  const hasData = rate !== null;

  return (
    <Tile disabled={!hasData} onClick={hasData ? onClick : undefined}>
      {hasData && <Icon />}
      {formatRate(rate)}
    </Tile>
  );
};

export default StatTile;
